import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import Crypto from './utils.js'
import env from './env.js'
import { Toast } from 'vant';
import { Dialog } from 'vant';
import Router from '@/router'
import { $getParkingIdByMode } from '@/utils/index.js'


axios.defaults.timeout = 15000 // 设置请求超时时间 15s
// if (env.getEnv() == '01') {
//   axios.defaults.baseURL = env.getEnvUrl(); // 从配置文件env.js导入
// }

axios.defaults.baseURL = env.getEnvUrl(); // 从配置文件env.js导入


const timestamp = Date.now().toString() // 毫秒级时间戳
const appid = '2021033115330001' // 小程序接口的AppId

// !按ASCII码从小到大排序
function obj2str (args) {
  // console.log('排序前', typeof args, args)
  var keys = Object.keys(args)
  keys = keys.sort() //参数名ASCII码从小到大排序（字典序）；
  var newArgs = {}
  keys.forEach(function (key) {
    //如果参数的值为空不参与签名
    if (args[key] != '' && args[key] != undefined && args[key] != null) {
      // if (args[key] != undefined && args[key] != null) {
      newArgs[key] = args[key]  //参数名区分大小写；
    }
  })
  var string = ''
  for (var k in newArgs) {
    string += '&' + k + '=' + newArgs[k]
  }
  string = string.substr(1)
  return string
}

// !请求拦截
axios.interceptors.request.use(config => {
  if (config.method == 'POST' || config.method == 'post') {
    // console.log('config.data instanceof FormData', config.data instanceof FormData)
    if (config.data instanceof FormData) {//!文件上传
    } else {
      // 拼接/补齐参数
      config.data = { AppId: appid, /* AppId*/ Nonce: timestamp, /* 时间戳*/ ...config.data }
      // ASCII排序
      const str = obj2str(config.data), reqSign = Crypto.Hash_encrypt(str)
      // 添加签名
      config.data = qs.stringify({ ...config.data, Sign: reqSign })
    }
  } else if (config.method == 'GET' || config.method == 'get') {
    // 拼接/补齐参数
    config.params = { AppId: appid, /* AppId*/ Nonce: timestamp, /*时间戳*/ ...config.params }
    // ASCII排序
    const str = obj2str(config.params), reqSign = Crypto.Hash_encrypt(str)
    // 添加签名
    config.params = { ...config.params, Sign: reqSign }
  }
  return config
}, (res) => {
  return Promise.reject(res)
})

// !响应拦截
axios.interceptors.response.use(
  async (res) => {
    if (res.data.RetCode != 0) {// 大良自营：服务端返回的状态码不等于0，则表示有错误，进一步处理
      console.log('返回码非0，出错了：', res.data.Message)
      Toast({ message: res.data.Message, duration: 2000 })
      // 如果code是5 AccessToken无效
      if (res.data.RetCode == 5) {
        console.log('重新登录')
        return Promise.reject(res)
        // 如果是token不存在
      } else if (res.data.RetCode == 117) {
        //跳转商家登录  cf20220505
        Dialog.confirm({
          title: '温馨提示',
          message: res.data.Message,
          showCancelButton: true,
          confirmButtonColor: '#3679ff',
          cancelButtonColor: '#666',
        }).then(() => {
          // on confirm
          window.localStorage.removeItem(`loginAccount_${Router.app._route.query.mode}`);
          window.localStorage.removeItem(`loginToken_${Router.app._route.query.mode}`);
          Router.replace('/parkingBusiness/businessIndex?mode=' + Router.app._route.query.mode);
        })
          .catch(() => {
            // on cancel
          });
      } else if (res.data.RetCode == 118) {
        Dialog.confirm({
          title: '温馨提示',
          message: '请重试',
          confirmButtonColor: '#3679ff',
          showCancelButton: false,
          cancelButtonColor: '#666',
        }).then(() => {
          // on confirm
          Router.replace(`${Router.app._route.path}?mode=${$getParkingIdByMode(res.data.Data.parkingid)}`);
          Router.go(0)
        }).catch(() => {
          // on cancel
        });

      } else {
        return Promise.reject(res)
      }
    } else {// 如果返回的是0，则通过
      // console.log('拦截通过')
      return res
    }
  },
  (res) => {
    console.log('Request报错信息：', res)
    if (res.message.indexOf('Network') != -1) {
      Toast('请检查网络连接！');
      return Promise.reject(res)
    } else if (res.message.indexOf('timeout') != -1 && res.code == 'ECONNABORTED') {
      Toast('网络异常，请稍后再试！');
      return Promise.reject(res);
    } else {
      Toast(res.message);
      return Promise.reject(res)
    }
  })

export {
  axios
}


// WEBPACK FOOTER //
// ./src/utils/request/request.js